export const PICKLEBALL_DRILL_SKILLS = [
    { code: "pickleball_drill_forehand", label: "正手" },
    { code: "pickleball_drill_backhand", label: "反手" },
    { code: "pickleball_drill_serve", label: "發球" },
];

export const ALL_PICKLEBALL_DRILL_CODES = PICKLEBALL_DRILL_SKILLS.map((skill) => skill.code);

export const ALL_ORGANIZATION_ID = "all";

export const getPickleballSkillLabel = (code) => {
    const skill = PICKLEBALL_DRILL_SKILLS.find((item) => item.code === code);
    return skill ? skill.label : code;
};

const PICKLEBALL_DRILL_TABLE_NAMES = {
    pickleball_drill_serve: "Serve",
    pickleball_drill_forehand: "Forehand",
    pickleball_drill_backhand: "Backhand",
};

export const getPickleballDrillTableName = (code) => {
    if (!code) {
        return code;
    }
    return PICKLEBALL_DRILL_TABLE_NAMES[code] || code;
};
